import { useTheme } from '@mui/material';
import { EditIcon } from '../Icons';
import { EditButtonContainer } from './styles';
import { CSSProperties } from 'react';

export interface IEditButtonButton {
  handleClick: () => void;
  style?: CSSProperties;
  disabled?: boolean;
}

const EditButton = ({ handleClick, style, disabled }: IEditButtonButton) => {
  const theme = useTheme();
  return (
    <EditButtonContainer
      onClick={handleClick}
      style={style}
      disabled={disabled}
    >
      <EditIcon
        color={
          disabled ? '#C3C1CA' : (theme.palette.brand.primary.base as string)
        }
      />
    </EditButtonContainer>
  );
};

export default EditButton;
